import * as React from 'react';

export const ChevronIcon = ({
  height = '24px',
  width = '24px',
  secondaryColor,
  ...props
}: React.SVGProps<SVGSVGElement> & { secondaryColor?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <path d="M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path>
  </svg>
);
